import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import './OpalAlertModal.css';
import TauriImage from '../TauriImage/TauriImage';
import { createPortal } from "react-dom";

const OpalAlertModal = ({
    show,
    onHide,
    title,
    bodyText,
    subBodyText,
    onConfirm,
    confirmButtonText,
    cancelButtonText,
    modalType,
    Icon,
    hideFooter,
    loading,
    backdrop = true,
    keyboard = true
}) => {

    // Determine the buttons to show based on modalType
    const renderButtons = () => {
        if (modalType === 'message') {
            return (
                <Button className='opal-alert-close' onClick={onHide}>
                    Close
                </Button>
            );
        }
        return (
            <>
                <Button
                    className='opal-alert-confirm'
                    onClick={onConfirm}
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                            />
                            Loading...
                        </>
                    ) : confirmButtonText}
                </Button>
                <Button className='opal-alert-close' onClick={onHide}>
                    {cancelButtonText}
                </Button>
            </>
        );
    };

    const buttons = renderButtons();

    return createPortal(
        <Modal
            className='opal-alert-modal'
            show={show}
            onHide={onHide}
            centered
            backdrop={backdrop}
            keyboard={keyboard}
        >
            <Modal.Header className={!title || title === '' ? 'transparent' : ''}>
                {title}
            </Modal.Header>
            <Modal.Body>
                {
                    Icon && (
                        <TauriImage localImage={Icon} className={"icon"} alt='icon' />
                    )
                }
                <div>
                    <div dangerouslySetInnerHTML={{ __html: bodyText }} />
                    {subBodyText && (
                        <div className="opal-sub-body-text mt-2">
                            {subBodyText}
                        </div>
                    )}
                </div>
            </Modal.Body>
            {!hideFooter && buttons && (
                <Modal.Footer>
                    {buttons}
                </Modal.Footer>
            )}
        </Modal>,
        document.body
    );
};

export default OpalAlertModal;
